import { ReactNode, useMemo } from 'react'

import { Lookups as LookupsMock } from '@/mocks'
import { useQuery } from '@api/hooks'
import { LookupList } from '@domain'
import LookupsApi, { LookupsKey } from '@services/lookups.api'

import { LookupsContext } from './LookupContext'
import Lookup from './Lookups.types'
import { lookupsStatic } from './lookupStatic'

type Props = {
	children: ReactNode
}

/**
 * Provide a context for all lookup options.
 */
export default function LookupProvider({ children }: Props) {
	const { data } = useQuery({
		queryKey: LookupsKey.all,
		queryFn: LookupsApi.getAll,
	})

	const lookupData: LookupList = useMemo(
		() =>
			data
				? { ...data, ...lookupsStatic }
				: {
						[Lookup.BasketProcessSteps]: [],
						[Lookup.Brands]: [],
						[Lookup.BrandOwner]: [],
						[Lookup.Currencies]: [],
						[Lookup.MarkupTypes]: [],
						[Lookup.ExclusionFilters]: [],
						[Lookup.EnabledFilters]: [],
						[Lookup.MarketBasketSource]: [],
						[Lookup.MarketSegments]: [],
						[Lookup.MatchTypeFilters]: [],
						[Lookup.ProgramTypes]: [],
						[Lookup.PurchaseGroups]: [],
						[Lookup.Operators]: [],
						[Lookup.ReviewTypes]: [],
						[Lookup.SameManufacturerSwitchFilters]: [],
						[Lookup.SwitchCandidateInfo]: [],
					},
		[data]
	)

	return <LookupsContext.Provider value={lookupData}>{children}</LookupsContext.Provider>
}

/**
 * Used for mocking in tests/stories
 */
export function LookupProviderMocked({ children }: Props) {
	const value = useMemo((): LookupList => LookupsMock, [])
	return <LookupsContext.Provider value={value}>{children}</LookupsContext.Provider>
}
